import { load } from 'cheerio'
import handleHtmlData from 'utils/global/handleHtmlData'
import {
  updateCaseDetails,
  updateCaseDetailTables,
  updateTemplates,
  updateServiceTemplates,
} from './'

export const updateDynamicText = (editorProps) => {
  const { initialHtml } = editorProps
  const $ = load(initialHtml)

  const textTypes = [
    {
      id: 'service-information-template',
      handler: updateServiceTemplates,
    },
    {
      attribute: 'data-case-detail',
      handler: updateCaseDetails,
    },
    {
      attribute: 'data-case-detail-table',
      handler: updateCaseDetailTables,
    },
    {
      attribute: 'data-template',
      handler: updateTemplates,
    },
  ]

  textTypes.forEach((textType) => {
    const selector = textType.id
      ? `[id="${textType.id}"]`
      : `[${textType.attribute}]`

    const dynamicTextElements = $(selector)

    dynamicTextElements.each(function () {
      const element = $(this)
      handleDynamicTextElement({ element, textType, editorProps })
    })
  })

  // The merge writes no font onto a block: a stored box's blocks keep the
  // fonts their HTML names, so its lines sit on the strut they were designed
  // on. A block takes its text's font only from an edit that sets one: a
  // font command (pinSelectedBlockFonts) or a paste (pinEditorBlockFonts).
  return $('body').html()
}

const handleDynamicTextElement = ({ element, textType, editorProps }) => {
  const { attribute, handler } = textType

  const attributes = element.attr()
  const dynamicKey = attributes[attribute]
  const elementType = element[0].name

  const textTypeProps = {
    attribute,
    key: dynamicKey,
  }

  const elementProps = {
    type: elementType,
    element,
    properties: getElementProperties(attributes),
  }

  const dynamicTextProps = {
    textTypeProps,
    elementProps,
    editorProps,
  }

  handler(dynamicTextProps)
}

const getElementProperties = (attributes) => {
  const properties = attributes['data-properties']
  if (!properties) return {}

  const decodedProperties = handleHtmlData.decode(properties)
  return decodedProperties
}

export default updateDynamicText
